/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Nav_WatchInputs */

const en_fw_nav_watch = /** @type {(inputs: Fw_Nav_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch`)
};

const zh_fw_nav_watch = /** @type {(inputs: Fw_Nav_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观看`)
};

/**
* | output |
* | --- |
* | "Watch" |
*
* @param {Fw_Nav_WatchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_nav_watch = /** @type {((inputs?: Fw_Nav_WatchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Nav_WatchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_nav_watch(inputs)
	return zh_fw_nav_watch(inputs)
});
export { fw_nav_watch as "fw.nav.watch" }